import { UpdateEstatePlanningPersonalInfoBody } from '../api/useEstatePlanningPersonalInfoMutation';
import { DeductionsAndGiftsValues } from '../components/Deductions/Deductions.meta';
import { UpdatePersonalInfoBody } from '../api/useUpdatePersonalInfoMutation';

interface FormToBodyEstatePlanning {
  deductionsAndGifts: DeductionsAndGiftsValues;
  personalInfo: UpdatePersonalInfoBody;
  hasPartner: boolean;
  spouseTaxFilingState: number | null;
}

export const formToBodyEstatePlanning = ({
  deductionsAndGifts,
  personalInfo,
  hasPartner,
  spouseTaxFilingState,
}: FormToBodyEstatePlanning): UpdateEstatePlanningPersonalInfoBody => {
  return {
    PersonalInfo: personalInfo,

    EstatePlanning: {
      SpouseTaxFilingState: spouseTaxFilingState,

      DeductionsAndGifts: {
        PrincipalDeductionsAndGifts: {
          AdministrationExpenseDeductionAmount:
            deductionsAndGifts.principal.administrationExpenseDeductionAmount,
          LifetimeGiftingExemptionUsedAmount:
            deductionsAndGifts.principal.lifetimeGiftingExemptionUsedAmount,
        },
        ...(hasPartner
          ? {
              SpouseDeductionsAndGifts: {
                AdministrationExpenseDeductionAmount:
                  deductionsAndGifts.spouse?.administrationExpenseDeductionAmount,
                LifetimeGiftingExemptionUsedAmount:
                  deductionsAndGifts.spouse?.lifetimeGiftingExemptionUsedAmount,
              },
            }
          : {}),
      },
    },
  };
};
